import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { theme } from "antd";
import { __ } from "../../../../utils/i18n.js";
const UnauthAlternativePaths = ()=>{
    const { token } = theme.useToken();
    return /*#__PURE__*/ _jsxs("div", {
        className: "rc-account-v2-unauth-alt-paths",
        style: {
            borderTopColor: token.colorBorder,
            color: token.colorTextSecondary
        },
        children: [
            /*#__PURE__*/ _jsx("a", {
                href: "#/envato-purchase",
                className: "rc-account-v2-unauth-alt-paths__link",
                children: __("Bought at codecanyon.net? Create an account!")
            }),
            /*#__PURE__*/ _jsx("span", {
                className: "rc-account-v2-unauth-alt-paths__divider",
                "aria-hidden": "true",
                children: "\xb7"
            }),
            /*#__PURE__*/ _jsx("a", {
                href: "#/create-affiliate",
                className: "rc-account-v2-unauth-alt-paths__link",
                children: __("Want to promote our products? Become an affiliate!")
            })
        ]
    });
};
export { UnauthAlternativePaths };
